import { ChatDetails } from './chat-details'

export default ChatDetails
